import { render, staticRenderFns } from "./ReportStatus.vue?vue&type=template&id=2997a356&"
import script from "./ReportStatus.vue?vue&type=script&lang=js&"
export * from "./ReportStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports